import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MagnifyingGlass } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { miscApi } from "@/api";

export default function SearchDialog({ pid, open, onOpenChange }) {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const [loading, setLoading] = useState(false);

  const run = async (e) => {
    e?.preventDefault();
    if (!q.trim()) return;
    setLoading(true);
    try { setRes(await miscApi.search(pid, q)); } finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-popover max-w-2xl" data-testid="search-dialog">
        <DialogTitle className="sr-only">Rechercher dans le manuscrit</DialogTitle>
        <DialogDescription className="sr-only">Rechercher un mot, une expression, un personnage ou un lieu dans tout le manuscrit</DialogDescription>
        <form onSubmit={run} className="flex items-center gap-2 border-b border-border pb-3">
          <MagnifyingGlass size={20} className="text-muted-foreground" />
          <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher un mot, une expression, un personnage…"
            className="flex-1 bg-transparent outline-none text-lg font-serif" data-testid="search-input" />
        </form>
        <div className="max-h-[60vh] overflow-y-auto thin-scroll">
          {loading && <p className="text-muted-foreground text-sm py-6 text-center">Recherche…</p>}
          {res && !loading && (
            <>
              <p className="text-sm text-muted-foreground py-3" data-testid="search-summary">
                {res.total} occurrence(s) dans {res.chapters} chapitre(s).
              </p>
              <div className="space-y-2">
                {res.results.map((r) => (
                  <button key={r.chapter_id} data-testid={`search-result-${r.index}`}
                    onClick={() => { onOpenChange(false); navigate(`/project/${pid}/editor/${r.chapter_id}`); }}
                    className="w-full text-left border border-border rounded-sm p-3 hover:bg-surface-hover transition-colors">
                    <div className="flex items-center justify-between mb-1">
                      <span className="font-serif">{r.title}</span>
                      <span className="text-xs font-mono text-primary">{r.count}×</span>
                    </div>
                    {r.snippets.map((s, i) => <p key={i} className="text-xs text-muted-foreground line-clamp-1">{s}</p>)}
                  </button>
                ))}
              </div>
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
